module.exports = __webpack_public_path__ + "static/media/great.de970948.svg";